import { useState, useEffect } from "react";
import throttle from "lodash.throttle";

const useIsMobile = (breakpoint = 767) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const updateSize = throttle(() => {
      setIsMobile(!!window.matchMedia(`(max-width: ${breakpoint}px)`)?.matches);
    }, 250);
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [breakpoint]);
  return isMobile;
};

export default useIsMobile;
